import { hasValue } from '../../internal';
import { unTriggeredRuleResult, validateLength } from '../utils';

/**
 * Checks the value for minimum length
 * @param {ValidationRuleParameters}  params  The validation parameters from the component properties
 * @param {string}                    value   The value the user entered
 * @returns {{message: string, isInvalid: boolean, name: string}}
 */
export const minLengthRule = (params, value) => {
  if (typeof value !== 'string') {
    return unTriggeredRuleResult;
  }
  const ruleResults = {
    validationState: {
      isValid: true,
      type: undefined,
      messageKey: 'lessThanMinLength'
    },
    triggered: false
  };
  const results = hasValue(value) && validateLength(value, params.minLength, 'lessThan');
  if (results) {
    ruleResults.validationState.isValid = !results;
    ruleResults.triggered = results;
    ruleResults.validationState.type = 'error';
    ruleResults.validationState.message = params.customErrorMessages?.lessThanMinLength || `${params.minLength} characters required`;
  }
  return ruleResults;
};